@switch (context ? context.type : '') {
    @default {
        <fui-edit-select-input [addable]="showAddOption" (added$)="added$.emit($event)"
                               [extendable]="showExtendedSearchOption" (extended$)="extended$.emit($event)"
                               [optionOpenable]="showOptionOpenOption" (optionOpened$)="optionOpened$.emit($event)"
                               [allowDirectInput]="allowDirectInput" [isNumeric]="isNumeric"
                               [control]="control" [disabled]="disabled"
                               [field]="valueField" [filterable]="internallyFilterable"
                               (filtered$)="filtered$.emit($event)" #input [key]="labelField" [label]="label"
                               [loading]="loading" [(ngModel)]="value" [options]="options"
                               (focussed$)="onFocussed($event)" [placeholder]="placeholder" [total]="total"
                               (select$)="select$.emit($event)" (action$)="action$.emit($event)" [actions]="actions"
                               [clearSelectionOptionLabel]="clearSelectionOptionLabel"
                               [optionElementHandler]="optionElementHandler"
                               [allowClearSelectionOption]="allowClearSelectionOption">
            <ng-container ngProjectAs="fui-content-section" *ngTemplateOutlet="content"></ng-container>
        </fui-edit-select-input>
    }
    @case (contextType.FILTER) {
        <fui-filter-select-input [addable]="showAddOption" (added$)="added$.emit($event)"
                                 [extendable]="showExtendedSearchOption" (extended$)="extended$.emit($event)"
                                 [optionOpenable]="showOptionOpenOption" (optionOpened$)="optionOpened$.emit($event)"
                                 [allowDirectInput]="allowDirectInput" [isNumeric]="isNumeric"
                                 [field]="valueField" [control]="control" [disabled]="disabled"
                                 (filtered$)="filtered$.emit($event)" #input [key]="labelField"
                                 [filterable]="internallyFilterable" [label]="label" [loading]="loading"
                                 [options]="options"
                                 [placeholder]="placeholder"
                                 [(ngModel)]="value" [total]="total"
                                 (select$)="select$.emit($event)" (action$)="action$.emit($event)" [actions]="actions"
                                 (focussed$)="onFocussed($event)"
                                 [clearSelectionOptionLabel]="clearSelectionOptionLabel"
                                 [allowClearSelectionOption]="allowClearSelectionOption">
            <ng-container ngProjectAs="fui-content-section" *ngTemplateOutlet="content"></ng-container>
        </fui-filter-select-input>
    }
    @case (contextType.INLINE) {
        <fui-inline-select-input [addable]="showAddOption" (added$)="added$.emit($event)"
                                 [extendable]="showExtendedSearchOption" (extended$)="extended$.emit($event)"
                                 [optionOpenable]="showOptionOpenOption" (optionOpened$)="optionOpened$.emit($event)"
                                 [allowDirectInput]="allowDirectInput" [isNumeric]="isNumeric"
                                 [control]="control" [disabled]="disabled" [field]="valueField"
                                 (filtered$)="filtered$.emit($event)" #input [key]="labelField"
                                 [filterable]="internallyFilterable"
                                 (select$)="select$.emit($event)" (action$)="action$.emit($event)" [actions]="actions"
                                 [label]="label" [loading]="loading" [options]="options" [placeholder]="placeholder"
                                 [(ngModel)]="value" [total]="total"
                                 (focussed$)="onFocussed($event)"
                                 [clearSelectionOptionLabel]="clearSelectionOptionLabel"
                                 [allowClearSelectionOption]="allowClearSelectionOption">
            <ng-container ngProjectAs="fui-content-section" *ngTemplateOutlet="content"></ng-container>
        </fui-inline-select-input>
    }
    @case (contextType.HEADER) {
        <fui-header-select-input [addable]="showAddOption" (added$)="added$.emit($event)"
                                 [extendable]="showExtendedSearchOption" (extended$)="extended$.emit($event)"
                                 [optionOpenable]="showOptionOpenOption" (optionOpened$)="optionOpened$.emit($event)"
                                 [allowDirectInput]="allowDirectInput" [isNumeric]="isNumeric"
                                 [control]="control" [disabled]="disabled" [field]="valueField"
                                 (filtered$)="filtered$.emit($event)" #input [key]="labelField"
                                 [filterable]="internallyFilterable"
                                 (select$)="select$.emit($event)" (action$)="action$.emit($event)" [actions]="actions"
                                 [label]="label" [loading]="loading" [options]="options" [placeholder]="placeholder"
                                 [(ngModel)]="value" [total]="total"
                                 (focussed$)="onFocussed($event)"
                                 [clearSelectionOptionLabel]="clearSelectionOptionLabel"
                                 [allowClearSelectionOption]="allowClearSelectionOption">
            <ng-container ngProjectAs="fui-content-section" *ngTemplateOutlet="content"></ng-container>
        </fui-header-select-input>
    }
    @case (contextType.PILL) {
        <fui-pill-select-input [addable]="showAddOption" (added$)="added$.emit($event)" [removable]="removable"
                               [extendable]="showExtendedSearchOption" (extended$)="extended$.emit($event)"
                               [optionOpenable]="showOptionOpenOption" (optionOpened$)="optionOpened$.emit($event)"
                               [allowDirectInput]="allowDirectInput" [isNumeric]="isNumeric"
                               [control]="control" [disabled]="disabled"
                               [field]="valueField" (filtered$)="filtered$.emit($event)" #input [key]="labelField"
                               [filterable]="internallyFilterable" [label]="label" [loading]="loading"
                               [(ngModel)]="value"
                               [options]="options" [placeholder]="placeholder"
                               [total]="total"
                               (select$)="select$.emit($event)" (action$)="action$.emit($event)" [actions]="actions"
                               (removed$)="remove()" (focussed$)="onFocussed($event)"
                               [allowClearSelectionOption]="allowClearSelectionOption"
                               [clearSelectionOptionLabel]="clearSelectionOptionLabel">
            <ng-container ngProjectAs="fui-content-section" *ngTemplateOutlet="content"></ng-container>
        </fui-pill-select-input>
    }
}
<ng-template #content>
    <ng-content select="fui-content-section"></ng-content>
</ng-template>
